//#region ../error-codes/dist/error-codes.mjs
var RUNTIME_012 = "RUNTIME-012";
//#endregion
exports.RUNTIME_012 = RUNTIME_012; //# sourceMappingURL=error-codes.cjs.map
